import Empty from './_components/empty.vue';
import SearchBar from './_components/search-bar.vue';
export default {
    components: { Empty, SearchBar },
    methods: {
        searchAgents(data) {
            let { address, agentName } = data;
            this.pageNum = 1;
            this.setSearchParams({ address, name: agentName });
            this.getAgents();
        }
    }
};
